import React, { useEffect, useState } from 'react';
import axios from '../AxiosConfig';
import { Link, useNavigate } from 'react-router-dom';

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        const response = await axios.get('/api/auth/status');
        setIsAuthenticated(response.data.isAuthenticated);
        setIsAdmin(response.data.isAdmin);
      } catch (error) {
        console.error('Failed to check authentication status:', error);
        setIsAuthenticated(false);
        setIsAdmin(false);
      }
    };

    checkAuthStatus();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post('/api/auth/logout');
      setIsAuthenticated(false);
      setIsAdmin(false);
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <>
  
      {isCollapsed && (
        <div className="bg-dark text-white" 
             style={{position: 'fixed', top: 10, left: 10, zIndex: 1000, padding: '5px 10px', borderRadius: '5px', cursor: 'pointer',}}
             onClick={() => setIsCollapsed(false)}>
          ☰
        </div>
      )}

      {/* Sidebar */}
      <div className={`d-flex flex-column bg-dark text-white vh-100`}
           style={{width: isCollapsed ? '0px' : '250px', position: 'fixed', top: 0, left: 0, transition: 'width 0.3s', overflow: 'hidden',}}>
        {!isCollapsed && (
          <div className="d-flex align-items-center justify-content-between p-3">
            <h4 className="text-center mb-0">CSR Metaportal</h4>
            <div className="text-white"
                 style={{cursor: 'pointer', padding: '5px 10px', backgroundColor: '#343a40', borderRadius: '5px', border: '1px solid white',}}
                 onClick={() => setIsCollapsed(true)}>
              ←
            </div>
          </div>
        )}

        {!isCollapsed && (
          <div className="p-3">
            <ul className="nav flex-column">
              <li className="nav-item mb-2">
                <Link to="/" className="nav-link text-white">
                  Home
                </Link>
              </li>
              {isAuthenticated && (
                <>
                  {!isAdmin && (
                    <li className="nav-item mb-2">
                      <Link to="/myOrg" className="nav-link text-white">
                        My Organization
                      </Link>
                    </li>
                  )}
                  {isAdmin && (
                    <>
                      <li className="nav-item mb-2">
                        <Link to="/myOrg" className="nav-link text-white">
                          My Organization
                        </Link>
                      </li>
                      <li className="nav-item mb-2">
                        <Link to="/admin" className="nav-link text-white">
                          Admin
                        </Link>
                      </li>
                    </>
                  )}
                </>
              )}
            </ul>
          </div>
        )}
        <div className="mt-auto p-3">
          {!isCollapsed && (
            <button className={`btn ${isAuthenticated ? 'btn-danger' : 'btn-primary'} w-100`}
                    onClick={isAuthenticated ? handleLogout : () => navigate('/login')}>
              {isAuthenticated ? 'Logout' : 'Login'}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
